import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { Box, Grid, Typography } from '@material-ui/core';
import useStyles from '../../Main.style';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import useCalendarEvents from '../../../../hooks/useCalendarEvents';
import { getLoggedInUserData } from '../../../../utils/Helper';

const CalendarDashboardView = () => {
  const [weekDatesofEvents, setWeekDatesofEvents] = useState({});
  const [notificationRole, setNotificationRole] = useState('');
  const { getCalendarEventsForWeek } = useCalendarEvents();
  const classes = useStyles();
  const loggedInUserData = getLoggedInUserData();
  let calendarEventsData = {};
  const navigate = useNavigate();
  const loadCalendarEventsForWeek = async () => {
    let weekDatesObj = {};

    if (Object.keys(calendarEventsData).length === 0) {
      calendarEventsData = await getCalendarEventsForWeek();
    }

    if (Object.keys(calendarEventsData).length > 0) {
      weekDatesObj = calendarEventsData?.usersResult?.reduce((result, current) => {
        const date = current.dateFrom;
        if (!result[date]) {
          result[date] = [];
        }
        result[date].push(current);
        return result;
      }, {});

      const sortedWeekDatesOfEvents = Object.entries(weekDatesObj ?? [])
        .sort(([a], [b]) => new Date(a) - new Date(b)) // Change b - a to a - b for ascending order
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

      setWeekDatesofEvents(sortedWeekDatesOfEvents);
    }
  };

  const notificationPermission = () => {
    if (loggedInUserData.roleId === 1) {
      setNotificationRole('Leadership');
    } else if (loggedInUserData.roleId === 0) {
      setNotificationRole('Employees');
    } else if (loggedInUserData.roleId === 2) {
      setNotificationRole('alumni');
    }
  };
  useEffect(() => {
    loadCalendarEventsForWeek();
  }, []);

  useEffect(() => {
    notificationPermission();
  }, []);

  return (
    <>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h5">This Week's Events</Typography>
            <Box mt={0.5} />
          </Grid>

          {Object.keys(weekDatesofEvents).length > 0 ? (
            <>
              {Object.keys(weekDatesofEvents).map((day) => {
                const dayEvents = weekDatesofEvents[day].filter(
                  (e) =>
                    e?.receivers?.toLowerCase() === notificationRole?.toLowerCase() ||
                    e?.receivers?.toLowerCase() === 'all',
                );
                if (dayEvents.length === 0) return null;
                return (
                  <Grid item xs={12} key={day}>
                    <Box className={classes.innercontentWhite}>
                      <Typography variant="h5" style={{ fontSize: '13px' }}>
                        {moment(day).isSame(moment(), 'day') && 'Today -'}{' '}
                        {moment(day).format('dddd, MMMM Do')}
                      </Typography>
                    </Box>
                    {dayEvents.map((e, idx) => {
                      const isLeaveEvent =
                        e.type === 'Out of Office (OOO)' || e.type === 'Maternity/Paternity Leave';
                      const employeeName =
                        isLeaveEvent && e.eventForUserDetails
                          ? `${e.eventForUserDetails.firstName} ${e.eventForUserDetails.lastName}`
                          : null;
                      return (
                        <Box key={idx} className={classes.innercontentWhite} mt={2}>
                          <Box>
                            <Typography variant="h5">
                              {employeeName ? `${e.name} - ${employeeName}` : e.name}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography variant="body2">{e.description}</Typography>
                          </Box>
                        </Box>
                      );
                    })}
                  </Grid>
                );
              })}
            </>
          ) : (
            <Grid item xs={12}>
              <Box className={classes.innercontentWhite}>
                <Box>
                  <Typography variant="body2">No events this week</Typography>
                </Box>
              </Box>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="flex-end" alignItems="flex-end" height={1} mt={0.5}>
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <Box>
              <Typography
                variant="caption"
                color="textPrimary"
                onClick={() => navigate('/app/calendarnotification')}
                style={{ cursor: 'pointer' }}
              >
                View all
              </Typography>
            </Box>
            <Box className={classes.ViewAll}>
              <ArrowForwardIcon />
            </Box>
          </Box>
        </Box>
      </Grid>
    </>
  );
};
export default CalendarDashboardView;
